module.exports = __webpack_public_path__ + "static/media/completed.1927a331.svg";